export function formatDate(date: Date | string): string {
  const d = typeof date === "string" ? new Date(date) : date;
  // Use local date components to avoid timezone issues
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function formatDateTime(date: Date | string): string {
  const d = typeof date === "string" ? new Date(date) : date;
  return d.toLocaleString("ru-RU", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function getDefaultPeriod(): { from: string; to: string } {
  return getCurrentMonthPeriod();
}

// Get period for current month (1st to today)
export function getCurrentMonthPeriod(): { from: string; to: string } {
  const now = new Date();
  const from = new Date(now.getFullYear(), now.getMonth(), 1);
  const to = now;

  return {
    from: formatDate(from),
    to: formatDate(to),
  };
}

// Get period for a specific month offset (0 = current, -1 = last month, -2 = month before)
export function getMonthPeriod(monthOffset: number): { from: string; to: string } {
  const now = new Date();
  const targetMonth = new Date(now.getFullYear(), now.getMonth() + monthOffset, 1);

  const from = new Date(targetMonth.getFullYear(), targetMonth.getMonth(), 1);

  // For current month, use today; for past months, use last day of month
  let to: Date;
  if (monthOffset === 0) {
    to = now;
  } else {
    to = new Date(targetMonth.getFullYear(), targetMonth.getMonth() + 1, 0); // Last day of month
  }

  return {
    from: formatDate(from),
    to: formatDate(to),
  };
}
